module.exports = {
    config: {
        entities: {
            input: {
                titleKey: 'Schritt 1',
                subTitleKey: 'Dateneingabe',
            },
            dataCheck: {
                titleKey: 'Schritt 2',
                subTitleKey: 'Datenüberprüfung',
            },
            order: {
                titleKey: 'Schritt 3',
                subTitleKey: 'Bestellen',
            },
            waitUntilFixed: {
                titleKey: 'Schritt 4',
                subTitleKey: 'Bestätigung abwarten',
            },
            done: {
                titleKey: 'Schritt 5',
                subTitleKey: 'Fertig',
            },
        },
        symbols: {
            before: 'fi fi-check-circle',
            highlight: 'fi fi-clock',
            after: 'fi fi-circle-question',
        },
    },

    model: {
        progressKey: 'input',
    },

    methods: {
        updateProgressKey(progressKey) {
            if(progressKey === undefined) {
                progressKey = 'input'
            }
            this.model.progressKey = progressKey
            this.refresh()
        },
    },
}